import { useEffect } from "react"
import { useUserContext } from "context/UserContext"

export function useWebViewPageState({
    isWebView,
    appUserToken,
    loadingState,
}: {
    isWebView?: boolean
    appUserToken?: string | null
    loadingState?: boolean
}) {
    const { setIsWebView, setToken } = useUserContext()

    useEffect(() => {
        if (isWebView) {
            setIsWebView(true)
        }
        if (appUserToken) {
            setToken(appUserToken)
        }
    }, [appUserToken, isWebView, setToken, setIsWebView])

    useEffect(() => {
        if (!isWebView || typeof window === "undefined") {
            return
        }

        window.ReactNativeWebView?.postMessage?.(
            JSON.stringify({ isLoaded: !loadingState })
        )
    }, [isWebView, loadingState])
}
